import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsGoogleShopping() {
  return (
    <IntegrationDocTemplate
      title="Google Shopping (Merchant Center)"
      category="Marketplace · Discovery"
      status="in_progress"
      summary="Google Merchant Center API — product feed, performance metrics, Shopping Ads, conversion tracking. OAuth 2.0 via Google Cloud Console. Free for organic listings; paid for Shopping Ads."
      prerequisites={[
        'Google Merchant Center account (free at merchants.google.com).',
        'Google Cloud project with Content API for Shopping enabled.',
        'OAuth 2.0 client credentials.',
        'Optional: Google Ads account for paid Shopping campaigns.',
      ]}
      connectSteps={[
        'Text us "Google Shopping" with your phone number.',
        'Authorize Commerce Index in the Google OAuth popup.',
        'We push your existing catalog as a Merchant Center feed (one-time backfill).',
        'Hourly sync after that — inventory + price changes propagate to Google in <1 hour.',
      ]}
      syncedData={[
        { type: 'Product feed', detail: 'Title, description, price, GTIN, image_link, availability — full Merchant Center spec' },
        { type: 'Inventory updates', detail: 'productstatuses API + supplemental feeds for high-frequency updates' },
        { type: 'Performance', detail: 'Impressions, clicks, conversions per product via Reports API' },
        { type: 'Shopping Ads (optional)', detail: 'Campaign management via Google Ads API' },
      ]}
      agents={[
        { id: 'category_mapping_agent', name: 'category_mapping_agent', role: 'Maps your taxonomy to Google Product Category' },
        { id: 'catalog_enrichment_agent', name: 'catalog_enrichment_agent', role: 'Generates Merchant-Center-optimized titles + descriptions' },
      ]}
      troubleshooting={[
        { question: 'Products disapproved', answer: 'Most common: missing GTIN (our gtin_agent allocates from your GS1 prefix), image quality, or category mismatch. Check Merchant Center diagnostics.' },
        { question: 'Feed processing slow', answer: 'Full feeds process every 24h. Use supplemental feed + productstatuses API for real-time inventory/price updates.' },
      ]}
      supportLink="/contact"
    />
  );
}
